import { render, staticRenderFns } from "./DinamicoIndex.vue?vue&type=template&id=605b3f3c"
import script from "./DinamicoIndex.vue?vue&type=script&lang=js"
export * from "./DinamicoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports